/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="18.91"
        height="18.91"
        viewBox="0 0 18.91 18.91"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M9.45 0a9.46 9.46 0 1 0 9.45 9.45A9.45 9.45 0 0 0 9.45 0Zm0 17.91a8.46 8.46 0 1 1 8.45-8.46 8.45 8.45 0 0 1-8.45 8.46Zm-.18-3.35a.84.84 0 1 0 0-1.68.84.84 0 0 0 0 1.68Zm.46-10.23a3.34 3.34 0 0 0-2.68 1.36l.83.56a2.33 2.33 0 0 1 1.85-.92c1.06 0 1.72.54 1.77 1.44a2.1 2.1 0 0 1-1 1.84 3.28 3.28 0 0 0-1.63 2.48v.77h1v-.79c0-.49.43-1.08 1.23-1.68a3.07 3.07 0 0 0 1.44-2.69 2.58 2.58 0 0 0-.87-1.79 2.53 2.53 0 0 0-1.94-.58Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'CircleWithQuestionMarkIcon';

export default Icon;
